import { useNavigate } from 'react-router-dom';
import imageOne from '../../resource/community/danaathome/1.png'
import imageTwo from '../../resource/community/danaathome/4.png'
import imageThree from '../../resource/community/danaathome/2.png'
import imageFour from '../../resource/community/danaathome/3.png'
import TitleChnage from "../../Hook/TitleChnage";
import BookingCalendar from "../Calendar/BookingCalendar";


const Danaathome = () => {

    TitleChnage("Paritta at Home");

    const navigate = useNavigate();

    const handleClick = (event) => {

        const pathMap = {
         housepreparationfordana : '/housepreparationfordana',
         danaathomeform:'/danaathomeform'
        }
    
        const path = event.currentTarget.id;
        const targetPath = pathMap[path]
    
        if (targetPath){
          navigate(targetPath)
        }
      }


    return(
        <div className="paritta-page inside-pages">
        <div className="right-box">
            <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
        </div>

        <h1 className='font-main  p-4'>Dana at Home</h1>

        <p className="h4 p-4 mt-5 ">Offering Dana to the Sangha is a profoundly meritorious act, deeply cherished within the Buddhist tradition. Hosting Dana at home with family and friends is a meaningful way to commemorate special occasions, accumulate merit, and dedicate these merits to departed loved ones.</p>
        <p className="h4 p-4 mt-5 ">At Bhaddeka Vihari Monastery, there is an opportunity to invite the Sangha to receive Dana. However, due to the limited number of Sangha members residing at the monastery, only one member will be available to participate in the Dana ceremony.</p>
       <p className="h4 p-4 mt-5">To arrange a date for offering Dana at home, kindly refer to the Dana Calendar to select and secure an appropriate date for the event. This helps ensure a smooth and harmonious arrangement for all involved.</p>
       <div className="calander-box">
       <div className="calnder mt-5">             <BookingCalendar 
                            apiEndpoint="/get-dana-at-home-requests"
                            
                        /></div>
       </div>
        <p className="h4 p-4 mt-5 ">The video will also help you understand how the Dana is performed at home</p>


        <div className='btn-group mt-6'>
        <img src={imageFour} alt="Right Top Image" width={300} onClick={handleClick} id="housepreparationfordana" className="curser-pointer"/>
    </div>

        <div className="mt-6 calander-box align-item-center p-4 text-center">
                <div className="c-details text-left">
                    <h2 className='intro-text '>Contact Details</h2>
                    <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                    <p className="font-p">Mr Gamini : 0422 069 359</p>
                    <p className="font-p">WhatsApp : 0422 069 359</p>
                    <p className="font-p">E-mail : info@bvp.org.au</p>
                </div>
                <div className="d-button">
                <img src={imageTwo} alt="Right Top Image" className="right-image curser-pointer" width={300} id="danaathomeform" onClick={handleClick}  />
                </div>
            </div>




            <div className="bottom-box mt-5">
            <img src={imageThree} alt="bottom-image" width={600} />
        </div>
        </div>
    )
}

export default Danaathome;